var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkerEcontomat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pin_econtomat",
    "data-name": "Pin econtomat",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 48,
    viewBox: "0 0 32 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dropshape",
    d: "M32,15.412a16.857,16.857,0,0,1-1.746,7.549L17.011,47.406a1.147,1.147,0,0,1-2.01,0L1.574,22.619A17.145,17.145,0,0,1,0,15.412C0,6.739,7.373,0,16.009,0S32,6.735,32,15.412Z",
    fill: "#003f85"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e_icon",
    "data-name": "e icon",
    transform: "translate(10 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e_icon-2",
    "data-name": "e icon",
    d: "M1.823,16A1.9,1.9,0,0,1,.018,13.714L1.4,2.286A2.539,2.539,0,0,1,3.751,0h7.127a1.769,1.769,0,0,1,1.677,2.122A2.357,2.357,0,0,1,10.37,4.245H5.322L4.41,11.756H9.459a1.768,1.768,0,0,1,1.677,2.122A2.359,2.359,0,0,1,8.951,16ZM5.8,8.143a2,2,0,1,1,2,2A2,2,0,0,1,5.8,8.143Z",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerEcontomat);
export default __webpack_public_path__ + "static/media/marker-econtomat.be285646e633afd8780f573759fdad36.svg";
export { ForwardRef as ReactComponent };